module.exports = __webpack_public_path__ + "100516bc4bddde66b73f49ddb2472cb1.svg";